import Debug from 'debug'

/**
 * Let's export a class that mimics the Console API but uses Debug under the hood.
 * This allows us to use the same API as the Console API, but with the added
 * benefit of being able to enable/disable logging based on the DEBUG environment
 * variable.
 *
 *
 * @example
 * const debug = new DebugConsole('myNamespace')
 * debug.log('This is a log message')
 *
 */

export class DebugConsole {
  namespace: string
  log: Debug.Debugger
  info: Debug.Debugger
  warn: Debug.Debugger
  error: Debug.Debugger
  debug: Debug.Debugger
  trace: Debug.Debugger

  constructor(namespace: string) {
    this.namespace = namespace
    this.log = Debug(`${namespace}:log`)
    this.info = Debug(`${namespace}:info`)
    this.warn = Debug(`${namespace}:warn`)
    this.warn.color = 'yellow'
    this.error = Debug(`${namespace}:error`)
    this.error.color = 'red'
    this.debug = Debug(`${namespace}:debug`)
    this.trace = Debug(`${namespace}:trace`)
  }
  extend(namespace: string, delimiter = ':') {
    return new DebugConsole(`${this.namespace}${delimiter}${namespace}`)
  }
}

/**
 * This is a utility function to create a new DebugConsole instance with a
 * specific namespace.
 *
 * @param namespace - The namespace for the DebugConsole instance.
 * @returns A new DebugConsole instance.
 */
export function createDebugConsole(namespace: string): DebugConsole {
  return new DebugConsole(namespace)
}

export const logger = createDebugConsole('app')

export default logger
